// Copyright 2022
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/trait/remoteproperties/v1/remote_properties.proto (package msh.trait.remoteproperties.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message msh.trait.remoteproperties.v1.RemotePropertiesTrait
 */
export const RemotePropertiesTrait = proto3.makeMessageType(
  "msh.trait.remoteproperties.v1.RemotePropertiesTrait",
  [],
);

/**
 * @generated from enum msh.trait.remoteproperties.v1.RemotePropertiesTrait.PropertyType
 */
export const RemotePropertiesTrait_PropertyType = proto3.makeEnum(
  "msh.trait.remoteproperties.v1.RemotePropertiesTrait.PropertyType",
  [
    {no: 0, name: "PROPERTY_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PROPERTY_TYPE_TTS_API_KEY", localName: "TTS_API_KEY"},
    {no: 2, name: "PROPERTY_TYPE_STT_SERVICE_ACCOUNT", localName: "STT_SERVICE_ACCOUNT"},
    {no: 3, name: "PROPERTY_TYPE_LANGUAGE", localName: "LANGUAGE"},
  ],
);

/**
 * Events
 *
 * @generated from message msh.trait.remoteproperties.v1.RemotePropertiesTrait.FetchRemoteProperties
 */
export const RemotePropertiesTrait_FetchRemoteProperties = proto3.makeMessageType(
  "msh.trait.remoteproperties.v1.RemotePropertiesTrait.FetchRemoteProperties",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(RemotePropertiesTrait_PropertyType) },
  ],
  {localName: "RemotePropertiesTrait_FetchRemoteProperties"},
);

/**
 * Commands
 *
 * @generated from message msh.trait.remoteproperties.v1.RemotePropertiesTrait.SendRemoteProperties
 */
export const RemotePropertiesTrait_SendRemoteProperties = proto3.makeMessageType(
  "msh.trait.remoteproperties.v1.RemotePropertiesTrait.SendRemoteProperties",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(RemotePropertiesTrait_PropertyType) },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "RemotePropertiesTrait_SendRemoteProperties"},
);

